import { userAmsUserIdVar } from '../../../constants';
import type { UserInfo as CognitoUserInfo } from '../../../models/UserAWSCognitoInfo';
import { User } from '../../../utils/user';
import {
  type AnalyticsJwtPayload,
  type AnalyticsUserIdentity,
  resolveAnalyticsUserIdentityFromJwtPayload,
} from '../utils/resolveAnalyticsUserIdentity';
import { identifyAnalyticsUser } from './analyticsClient';

type SyncAnalyticsUserIdentitySources = {
  cognitoUserInfo?: CognitoUserInfo | null;
  amsUserIdVar?: string;
};

const getIdentityFromStoredTokens = (): AnalyticsUserIdentity | undefined => {
  const storedUser = User.getUserInfo();
  const userInfo = storedUser?.userInfo;

  if (!userInfo) {
    return undefined;
  }

  return resolveAnalyticsUserIdentityFromJwtPayload(userInfo as AnalyticsJwtPayload);
};

export const resolveAnalyticsUserIdentity = ({
  cognitoUserInfo,
  amsUserIdVar,
}: SyncAnalyticsUserIdentitySources): AnalyticsUserIdentity | undefined => {
  if (cognitoUserInfo) {
    const identity = resolveAnalyticsUserIdentityFromJwtPayload(cognitoUserInfo);

    if (identity) {
      return identity;
    }
  }

  const storedIdentity = getIdentityFromStoredTokens();

  if (storedIdentity) {
    return storedIdentity;
  }

  if (amsUserIdVar) {
    return { userId: amsUserIdVar };
  }

  return undefined;
};

export const syncAnalyticsUserIdentity = (sources: SyncAnalyticsUserIdentitySources): void => {
  const identity = resolveAnalyticsUserIdentity(sources);

  if (!identity) {
    return;
  }

  identifyAnalyticsUser(identity);
};

export const syncAnalyticsUserIdentityFromSession = (): void => {
  syncAnalyticsUserIdentity({ amsUserIdVar: userAmsUserIdVar() });
};
